import {
    EditCalendarRounded,
    ExploreRounded,
    InsightsRounded,
    RocketLaunchRounded,
} from '@mui/icons-material';
import GoalStepLayout, { type GoalOption } from './GoalStepLayout';
import type { OnboardingGoal } from './onboarding-goals';

interface GuidedGoalStepProps {
    value: OnboardingGoal | '';
    onSelect: (goal: OnboardingGoal) => void;
}

const OPTIONS: GoalOption[] = [
    { value: 'create', icon: EditCalendarRounded },
    { value: 'analyze', icon: InsightsRounded },
    // Explore rather than the sparkle: nothing on this path is AI-driven.
    { value: 'unsure', icon: ExploreRounded },
];

/**
 * The goal step for a user who finishes onboarding without connecting a profile.
 *
 * Drops every mention of Andie and all AI iconography, because Andie can do nothing useful for a
 * workspace with no profile. Each answer leads into a part of the product that works without one.
 */
const GuidedGoalStep = ({ value, onSelect }: GuidedGoalStepProps) => (
    <GoalStepLayout
        value={value}
        onSelect={onSelect}
        keyPrefix="onboarding.in-app.goal.no-connection"
        headerIcon={RocketLaunchRounded}
        options={OPTIONS}
    />
);

export default GuidedGoalStep;
